import BaseReducer from "../../utilities/BaseReducer";
import IAction from "../../models/IAction";
import IPreventivoState from "./models/IPreventivoState";
import RicercaPreventivoViewModel from "./models/RicercaPreventivoViewModel";
import PreventivoAction from "./PreventivoAction";
import PreventivoModel from "./models/PreventivoModel";
import ResponseEsitoModel from "stores/shared/models/ResponseEsitoModel";
import PreventiviUtenteModel from "./models/PreventiviUtenteModel";
import PreventivoQuestionarioViewModel from "./models/PreventivoQuestionarioViewModel";
import FormatUtility from "utilities/FormatUtility";
import PreventivoInformazioniUtenteModel from "./models/PreventivoInformazioniUtenteModel";

export default class PreventivoReducer extends BaseReducer<IPreventivoState> {
    public readonly initialState: IPreventivoState = {
        filtri: new RicercaPreventivoViewModel({}),
        risultati: [] as PreventivoModel[],
        corrente: new PreventivoModel({}),
        idUtente: 0,
        filtriInfoUtente: new PreventivoInformazioniUtenteModel({}),
    };

    public [PreventivoAction.REQUEST_SIMULAZIONE_PREVENTIVOS_FINISHED](
        state: IPreventivoState,
        action: IAction<PreventiviUtenteModel>
    ): IPreventivoState {
        return {
            ...state,
            risultati: action.payload!.preventiviSimulati,
            idUtente: action.payload!.idUtente,
        };
    }

    public [PreventivoAction.REQUEST_PREVENTIVOS_FINISHED](
        state: IPreventivoState,
        action: IAction<PreventivoModel[]>
    ): IPreventivoState {
        return {
            ...state,
            risultati: action.payload!,
        };
    }

    public [PreventivoAction.SET_FILTRI_RICERCA_PREVENTIVO_FINISHED](
        state: IPreventivoState,
        action: IAction<RicercaPreventivoViewModel>
    ): IPreventivoState {
        return {
            ...state,
            filtri: action.payload!,
        };
    }

    public [PreventivoAction.SET_FILTRI_QUESTIONARIO_RICERCA_PREVENTIVO_FINISHED](
        state: IPreventivoState,
        action: IAction<PreventivoQuestionarioViewModel>
    ): IPreventivoState {
        return {
            ...state,
            filtri: {
                ...state.filtri,
                preventivoQuestionario: action.payload!,
            } as RicercaPreventivoViewModel,
        };
    }

    public [PreventivoAction.RESET_RISULTATI_RICERCA_PREVENTIVO_FINISHED](state: IPreventivoState): IPreventivoState {
        return {
            ...state,
            risultati: [] as PreventivoModel[],
        };
    }

    public [PreventivoAction.RESET_SIMULAZIONE_PREVENTIVO_FINISHED](
        state: IPreventivoState,
        action: IAction<any>
    ): IPreventivoState {
        return {
            ...state,
            //filtri: new RicercaPreventivoViewModel({}),
            risultati: [] as PreventivoModel[],
        };
    }

    public [PreventivoAction.SAVE_PREVENTIVOS_FINISHED](
        state: IPreventivoState,
        action: IAction<ResponseEsitoModel>
    ): IPreventivoState {
        let idPreventivo = state.corrente.idPreventivo;
        if (action.payload && action.payload!.infoEsito !== "") {
            idPreventivo = parseInt(action.payload!.infoEsito);
            if (isNaN(idPreventivo)) {
                idPreventivo = state.corrente.idPreventivo;
            }
        }
        return {
            ...state,
            corrente: {
                ...state.corrente,
                idPreventivo: idPreventivo,
            } as PreventivoModel,
        };
    }
    public [PreventivoAction.GET_FILTRI_RICERCA_PREVENTIVO_FINISHED](
        state: IPreventivoState,
        action: IAction<RicercaPreventivoViewModel>
    ): IPreventivoState {
        let filtri = {
            ...state,
            filtri: action.payload!,
        };
        // return {
        //     ...state,
        //     filtri: action.payload!,
        // };
        let filtriFormatted = {
            ...state,
            filtri: {
                ...filtri.filtri,
                importoRichiesto:
                    FormatUtility.numberFromNumberWithSeparators(
                        FormatUtility.numberWithSeparators(filtri.filtri.importoRichiesto, "0.00")
                    )?.toString() ?? "",
                importoNettoRedditoMensile:
                    FormatUtility.numberFromNumberWithSeparators(
                        filtri.filtri.importoNettoRedditoMensile
                    )?.toString() ?? "",
                dataNascita: FormatUtility.dateInGivenFormat(filtri.filtri.dataNascita, "DD/MM/YYYY") ?? null,
                dataAssunzione: FormatUtility.dateInGivenFormat(filtri.filtri.dataAssunzione, "DD/MM/YYYY") ?? null,
            } as RicercaPreventivoViewModel,
        };
        return filtriFormatted;
    }

    public [PreventivoAction.SET_REGISTRAZIONE_ANONIMA_FINISHED](
        state: IPreventivoState,
        action: IAction<PreventivoInformazioniUtenteModel>
    ): IPreventivoState {
        let filtri = {
            ...state,
            filtriInfoUtente: action.payload!,
        };   
        return filtri;



    }
}
